import List from "./list/LabelReports";

export default { List };
